export default __webpack_public_path__ + "static/media/katika-logo.13366352.png";